<mat-nav-list class="sd_bar">
  <button class="closeSidebar" (click)="toggleSidenav()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="logo-brand">
    <figure class="logo">
      <img src="assets/images/prepbase.png" alt="logo" />
    </figure>
    <figure class="logo1">
      <img src="assets/images/prepbase_smll.png" alt="logo" />
    </figure>
    <div class="toggle" (click)="toggleSidenavWeb()">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  @for (item of sideBar; track $index) {
    <div>
      @if (item.isView) {
        @if (!item.isSubMenu) {
          <mat-list-item
            [routerLink]="item.path"
            routerLinkActive="active"
            matTooltip="{{ item.label }}"
            matTooltip="Tooltip!"
            matTooltipPosition="right"
            (click)="toggleSidenav()">
            <figure class="sd_cn">
              <img src="{{ item.icon }}" alt="" />
            </figure>
            <div class="sidenav-item">
              <h5 class="lead">{{ item.label | translate }}</h5>
            </div>
          </mat-list-item>
        } @else {
          <mat-accordion *ngIf="item.isSubMenu">
            <mat-expansion-panel class="drop_lst_nv">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-list-item
                    matTooltip="{{ item.label }}"
                    matTooltip="Tooltip!"
                    matTooltipPosition="right"
                    (click)="toggleSidenav()">
                    <figure class="sd_cn" mat-raised-button>
                      <img src="{{ item.icon }}" alt="" />
                    </figure>
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.label | translate }}</h5>
                    </div>
                  </mat-list-item>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list-item
                *ngFor="let sub of item.subMenuItems"
                [routerLink]="sub.path"
                matTooltip="{{ item.label }}"
                matTooltip="Tooltip!"
                matTooltipPosition="right"
                routerLinkActive="active"
                (click)="toggleSidenav()">
                <figure class="sd_cn">
                  <img src="{{ sub.icon }}" alt="images" />
                </figure>
                <div class="sidenav-item">
                  <h5 class="lead">{{ sub.label | translate }}</h5>
                </div>
              </mat-list-item>
            </mat-expansion-panel>
          </mat-accordion>
        }
      }
    </div>
  }
  <button class="aside_profile_btn" routerLink="/manage-profile">
    <figure>
      <img
        [src]="profile?.image ? profile?.image : assetsConst.adminIcon"
        alt="adminProfile" />
    </figure>
    <p>
      <strong>{{ profile?.name }}</strong>
      <span>{{ profile?.email }}</span>
    </p>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</mat-nav-list>
